import { render, staticRenderFns } from "./EditarDatosPersona.vue?vue&type=template&id=1724f444&"
import script from "./EditarDatosPersona.vue?vue&type=script&lang=js&"
export * from "./EditarDatosPersona.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports